import { StrictMode } from 'react'
import { ConfigProvider, Empty } from 'antd'
import locale from 'antd/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

dayjs.locale('zh-cn')

const zhCNLocale = {
  ...locale,
  Table: {
    ...locale.Table,
    emptyText: '暂无数据',
  },
  Pagination: {
    ...locale.Pagination,
    items_per_page: '条/页',
    jump_to: '跳至',
    jump_to_confirm: '确定',
    page: '页',
  },
  Image: {
    ...locale.Image,
    preview: '',
  },
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ConfigProvider
      locale={zhCNLocale}
      renderEmpty={() => <Empty description="暂无数据" />}
    >
      <App />
    </ConfigProvider>
  </StrictMode>,
)
